import gql from 'graphql-tag';

import { RequestLineFieldsFragment } from '../constants';

const NAME =
  'compositions_CaseRequestsPanel_RequestAssetsForm_updateAssetMutation';

export default gql`
  mutation ${NAME} ($id: ID!, $asset: AssetParams!) {
    updateAsset(input: { id: $id, patch: $asset }) {
      asset {
        id
        unitNumber
        droppedUnit
        assetType
        trailerType
        canDelete
      }

      updatedRequestLines { ...RequestLineFields }
      updatedRequestAgreementLines { ...RequestLineFields }
      updatedSuppliedLines { ...RequestLineFields }
    }
  }
  ${RequestLineFieldsFragment}
`;



// WEBPACK FOOTER //
// ./src/compositions/CaseRequestsPanel/CaseRequestsPanelContext/withRequestAssetActions/updateAssetMutation.js